import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdateScheduledOrderFOBActions } from "store/ducks/ordersFob";

export function* updateScheduledOrderFOBRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/orders-fob-scheduled/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdateScheduledOrderFOBActions.success(data));
    notify("success", "Ordem atualizada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdateScheduledOrderFOBActions.failure(errorMessage));
  }
}
